var _style, _g, _g2, _g3, _g4, _g5, _defs, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.1;fill:#FFFFFF;}\n\t.st3{fill:#FFF494;}\n\t.st4{fill:#37474F;}\n\t.st5{fill:#263238;}\n\t.st6{fill:#455A64;}\n\t.st7{fill:#FAFAFA;}\n\t.st8{fill:#E6E6E6;}\n\t.st9{fill:#E0E0E0;}\n\t.st10{fill:#FFF194;}\n\t.st11{opacity:0.4;fill:#FFFFFF;}\n\t.st12{opacity:0.1;}\n\t.st13{opacity:0.2;}\n\t.st14{fill:#EBEBEB;}\n\t.st15{clip-path:url(#XMLID_2_);}\n\t.st16{fill:#F0F0F0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor_12_",
    className: "st0",
    d: "M87.38,402.18c90.42,46.47,237.03,46.47,327.45,0c90.42-46.47,90.42-121.82,0-168.3 c-90.42-46.47-237.03-46.47-327.45,0C-3.04,280.36-3.04,355.71,87.38,402.18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Plants_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2735_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2738_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2740_",
    className: "st1",
    d: "M407.51,277.69c0.11-6.21,6.61-22.45,13.2-30.41c6.59-7.95,16.83-13.68,23.98-11.09 c6.67,2.41,5.79,11.2-2.45,16.88c-8.24,5.69-20.6,12.8-24.35,22.81l-7.72,12.23L407.51,277.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2739_",
    className: "st2",
    d: "M407.51,277.69c0.11-6.21,6.61-22.45,13.2-30.41c6.59-7.95,16.83-13.68,23.98-11.09 c6.67,2.41,5.79,11.2-2.45,16.88c-8.24,5.69-20.6,12.8-24.35,22.81l-7.72,12.23L407.51,277.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2736_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2737_",
    className: "st1",
    d: "M408.69,282.73c0.2-0.01,0.37-0.16,0.42-0.36c4.53-21.14,21.99-38.07,32.32-41.7 c0.24-0.08,0.36-0.34,0.28-0.58c-0.08-0.24-0.34-0.37-0.58-0.28c-10.53,3.7-28.31,20.91-32.91,42.37 c-0.05,0.24,0.1,0.49,0.35,0.54C408.6,282.73,408.65,282.74,408.69,282.73z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2730_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2733_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2734_",
    className: "st1",
    d: "M411.61,296.36c1.06-3.47,5.42-9.16,12.41-13.8c7.72-5.13,17.42-7.39,19.72-11.45 c2.76-4.88-1.31-9.6-9.17-8.77c-7.86,0.84-21.83,11.29-24.31,27.36L411.61,296.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2731_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2732_",
    className: "st1",
    d: "M410.16,292.67c0.17-0.01,0.33-0.12,0.4-0.29c6.82-18.05,20.79-24.19,27.23-24.91 c0.25-0.03,0.43-0.25,0.4-0.5c-0.03-0.25-0.24-0.43-0.5-0.4c-7.12,0.8-21.02,7.06-27.98,25.49c-0.09,0.23,0.03,0.5,0.26,0.59 C410.03,292.67,410.1,292.68,410.16,292.67z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2705_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2710_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2711_",
    className: "st3",
    d: "M79.15,345.05c-1.2,0.69-3.66-0.81-4.61-1.45c-1.62-1.08-2.93-2.62-3.8-4.36 c-1.01-2.02-1.27-4.19-0.95-6.42c0.16-1.16,0.49-2.29,0.81-3.42c0.32-1.11,0.64-2.21,0.95-3.32c0.31-1.09,0.63-2.22,0.49-3.34 c-0.29-2.27-2.3-3.86-4.13-5.23c-2.02-1.52-4.13-3.52-4.12-6.25c0.01-2.11,1.1-4.06,2.41-5.72c1.31-1.65,2.85-3.11,4.03-4.86 c0.85-1.26,1.51-2.73,1.37-4.24c-0.09-0.94-0.47-1.82-0.92-2.65c-0.96-1.78-2.24-3.41-2.9-5.32c-0.66-1.91-0.57-4.28,0.92-5.65 c1.22-1.12,3.04-1.28,4.7-1.17c1.53,0.1,3.03,0.79,4.37,1.54c4.33,2.41,6.81,7.54,11.41,9.4c1.77,0.72,3.72,0.87,5.57,1.36 s3.73,1.43,4.59,3.14c1.69,3.37-1.44,7.53-0.26,11.11c1.05,3.17,4.13,4.38,5.86,7.23c0.76,1.25,0.93,2.69,0.81,4.15 c-0.21,2.46-0.57,4.27-1.75,7.01c-0.98,2.26-3.85,6.31-3.85,6.31C100.08,332.99,79.33,344.94,79.15,345.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2708_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2709_",
    className: "st1",
    d: "M91.44,338.5c-0.01,0-0.01,0-0.01,0c-0.31-0.01-0.54-0.26-0.52-0.56 c0.89-21.43-9.2-45.08-16.54-51.95c-0.22-0.2-0.23-0.54-0.03-0.76c0.2-0.22,0.54-0.23,0.76-0.03 c7.49,7.01,17.79,31.06,16.89,52.78C91.96,338.27,91.73,338.5,91.44,338.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2706_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2707_",
    className: "st1",
    d: "M88.23,313.19c-0.05,0-0.11-0.01-0.16-0.02c-6.88-2.13-15.46-2.5-15.55-2.51 c-0.3-0.01-0.53-0.26-0.52-0.56c0.01-0.3,0.24-0.53,0.56-0.52c0.09,0,8.8,0.38,15.82,2.55c0.28,0.09,0.44,0.39,0.36,0.67 C88.67,313.04,88.46,313.19,88.23,313.19z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2720_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2770_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2771_",
    className: "st4",
    d: "M85.79,340.61l109.14,63.01c2.39,1.38,6.27,1.38,8.66,0L410.21,284.3 c2.39-1.38,2.39-3.62,0-5l-109.14-63.01c-2.39-1.38-6.27-1.38-8.66,0L85.79,335.61C83.4,336.99,83.4,339.23,85.79,340.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2768_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2769_",
    className: "st5",
    d: "M144.77,369.88c3.32,1.92,8.71,1.92,12.03,0c3.32-1.92,3.32-5.03,0-6.94 c-3.32-1.92-8.71-1.92-12.03,0C141.45,364.86,141.45,367.96,144.77,369.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2757_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2760_",
    className: "st6",
    d: "M194.92,403.62L85.79,340.61c-2.14-1.23-2.36-3.15-0.67-4.53 c-2.07,1.57-3.66,4.54-3.66,7.03v4.07c0,2.76,1.94,6.12,4.33,7.5l109.14,63.01c1.2,0.69,2.76,1.04,4.33,1.04v-14.07 C197.69,404.65,196.12,404.31,194.92,403.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2751_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2755_",
    className: "st5",
    d: "M410.21,298.37c2.39-1.38,4.33-4.74,4.33-7.5v-4.07c0-2.5-1.59-5.47-3.66-7.04 c1.69,1.38,1.47,3.3-0.67,4.54L203.58,403.62c-1.2,0.69-2.76,1.04-4.33,1.04v14.07c1.57,0,3.13-0.35,4.33-1.04L410.21,298.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2749_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2750_",
    className: "st7",
    d: "M212.91,390.56l-103.02-59.48c-1.43-0.83-1.43-2.17,0-3l169.42-97.88 c1.44-0.83,3.76-0.83,5.2,0l103.05,59.47c1.43,0.83,1.43,2.17,0,3L218.1,390.56C216.67,391.39,214.34,391.39,212.91,390.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2895_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2894_",
    className: "st8",
    d: "M186.12,310.53l60.93,35.18l-38.46,22.2c-1.19,0.69-3.14,0.69-4.33,0l-56.6-32.68 c-1.19-0.69-1.19-1.81,0-2.5L186.12,310.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2906_",
    className: "st9",
    d: "M247.04,345.7l-7.18-28.54c-0.17-0.68-0.54-1.3-1.08-1.74c0,0-0.01-0.01-0.01-0.01 c-0.55-0.46-1.22-0.75-1.93-0.81l-50.73-4.08L247.04,345.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2909_",
    className: "st9",
    d: "M247.04,345.7l-54.53-2.25c-1.35-0.05-2.46-1.08-2.62-2.42l-3.78-30.51L247.04,345.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2896_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2907_",
    className: "st7",
    d: "M247.04,345.7l-54.53-2.25c-1.35-0.05-2.46-1.08-2.62-2.42l-3.78-30.51l6.73,29.98 c0.12,0.54,0.59,0.94,1.15,0.99L247.04,345.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2897_",
    className: "st7",
    points: "198.3,343.36 206.43,369.16 208.59,367.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2898_",
    className: "st7",
    points: "145.5,333.98 147.66,332.73 190.18,338.67  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1872_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2899_",
    className: "st8",
    d: "M220.78,297.7l48.48,27.99c1.2,0.69,3.13,0.69,4.33,0l68.79-39.71c1.2-0.69,1.2-1.81,0-2.5 l-48.47-27.99c-1.2-0.69-3.13-0.69-4.33,0l-68.79,39.71C219.58,295.89,219.58,297.01,220.78,297.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_875_",
    className: "st7",
    d: "M259.32,294.01c-1.19-2.04-1.34-4.07-0.43-6.09c0.9-2.03,2.86-3.91,5.87-5.65 c3.44-1.98,7.01-3.25,10.73-3.78c3.71-0.54,7.41-0.41,11.1,0.39c3.69,0.8,7.25,2.19,10.69,4.17c3.21,1.85,5.4,3.76,6.57,5.73 c1.17,1.96,1.31,3.88,0.43,5.75c-0.88,1.87-2.72,3.61-5.53,5.24c-2.99,1.72-5.93,2.68-8.83,2.88c-2.9,0.19-5.4-0.32-7.51-1.53 c-1.03-0.59-1.61-1.24-1.75-1.92c-0.14-0.69,0.11-1.34,0.73-1.97c-1.63,0.13-3.24,0.02-4.82-0.33c-1.58-0.35-3.05-0.91-4.4-1.69 c-2.31-1.36-3.51-2.81-3.61-4.35c-0.1-1.54,1-2.97,3.31-4.3c2.86-1.65,5.93-2.44,9.22-2.37c3.29,0.07,6.41,0.96,9.37,2.67 c1.28,0.74,2.31,1.59,3.1,2.55c0.79,0.96,1.22,1.87,1.3,2.73l-9.03,5.21c-0.73,0.42-1.12,0.79-1.19,1.12 c-0.06,0.33,0.2,0.66,0.77,0.99c0.98,0.56,2.3,0.68,3.97,0.34c1.67-0.34,3.52-1.1,5.55-2.27c2.26-1.3,3.69-2.7,4.29-4.17 c0.6-1.48,0.44-2.94-0.47-4.4c-0.92-1.46-2.48-2.82-4.69-4.1c-4.04-2.33-8.25-3.58-12.63-3.75c-4.38-0.17-8.66,0.96-12.85,3.38 c-2.46,1.42-4.04,2.92-4.74,4.5c-0.7,1.58-0.6,3.13,0.32,4.64c0.92,1.51,2.5,2.92,4.76,4.23c1.23,0.71,2.57,1.31,4.01,1.79 c1.44,0.49,2.79,0.79,4.05,0.9c0.2,0.03,0.34,0.07,0.41,0.11c0.08,0.04,0.08,0.13,0,0.26l-1.32,1.85 c-0.1,0.12-0.16,0.18-0.19,0.2c-0.12,0.07-0.33,0.09-0.6,0.04c-1.53-0.19-3.14-0.57-4.83-1.14c-1.69-0.57-3.27-1.28-4.72-2.12 C262.65,297.95,260.51,296.05,259.32,294.01z M280.17,294.88c1.57,0.14,2.9-0.11,4.01-0.75l5.23-3.02 c-0.4-0.84-1.28-1.65-2.63-2.43c-1.71-0.99-3.54-1.49-5.5-1.52c-1.96-0.03-3.79,0.45-5.49,1.43c-1.46,0.84-2.17,1.67-2.13,2.49 c0.04,0.82,0.82,1.67,2.35,2.55C277.22,294.32,278.6,294.74,280.17,294.88z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2726_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2728_",
    className: "st5",
    d: "M347.26,252.9c0.73,0.42,1.92,0.42,2.65,0c0.73-0.42,0.73-1.11,0-1.53 c-0.73-0.42-1.92-0.42-2.65,0C346.53,251.8,346.53,252.48,347.26,252.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2721_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2724_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2725_",
    className: "st5",
    d: "M351.5,264.94c1.47,0.85,3.84,0.85,5.31,0c1.47-0.85,1.47-2.22,0-3.06 c-1.47-0.85-3.84-0.85-5.31,0C350.04,262.72,350.04,264.1,351.5,264.94z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2722_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2723_",
    className: "st5",
    d: "M347.76,259.61c0.98-0.56,0.93-1.51-0.12-2.11l-17.46-10.08 c-1.04-0.6-2.68-0.63-3.66-0.07c-0.98,0.57-0.92,1.51,0.12,2.11l17.46,10.08C345.15,260.14,346.78,260.17,347.76,259.61z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Letter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2817_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Letter_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2834_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2835_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2836_",
    className: "st10",
    d: "M121,132.44c0-1.96,1.39-4.37,3.09-5.36l158.15-91.31c1.71-0.99,4.48-0.99,6.18,0 l3.48,2.01c1.7,0.98,3.09,3.39,3.09,5.36v121.22c0,1.96-1.39,4.37-3.09,5.36l-158.15,91.31c-1.7,0.98-4.48,0.98-6.18,0 l-3.48-2.01c-1.7-0.98-3.09-3.39-3.09-5.36L121,132.44z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2833_",
    className: "st11",
    d: "M122.28,129.39l8.78,5.06l163.5-94.4c-0.56-0.97-1.33-1.81-2.18-2.31l-3.5-2 c-1.7-0.99-4.48-0.99-6.17,0l-158.23,91.35C123.61,127.57,122.84,128.42,122.28,129.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2819_",
    className: "st12",
    d: "M121,132.43v121.28c0,1.98,1.43,4.37,3.2,5.36l3.6,2.02c0.27,0.15,0.56,0.28,0.88,0.38 c0.41,0.13,0.85,0.23,1.31,0.29c0.83,0.1,1.71,0.07,2.52-0.09c0.21-0.04,0.42-0.1,0.62-0.16c0.14-0.04,0.26-0.09,0.38-0.15 c-0.59,0.2-1.1,0.18-1.53-0.03c-0.6-0.31-0.98-1.01-0.98-2.03V138.02c0-1.27,0.66-2.24,1.66-2.63l-1.66-0.94l-9.06-5.06 C121.36,130.35,121,131.45,121,132.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2818_",
    className: "st13",
    d: "M131,134.45l73.28,27.38c5.22,1.95,11.09,0.01,14.13-4.65l11.77-18.03l64.9-99.44 l-62.56,100.11l62.88,24.61c-0.01,1-0.38,2.11-0.97,3.09l-62.09-27.41l-13.67,21.88c-3.15,5.02-9.5,6.98-14.91,4.58l-9.74-4.3 l-62.08,99.07c-0.59-0.31-0.95-1.01-0.95-2.03v-2.02l62.72-95.15L131,134.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1873_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2870_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2866_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2868_",
    className: "st4",
    d: "M149.41,106.13L138.6,99.9c0,0-0.01,0-0.01-0.01l-0.1-0.06l-0.01,0.02 c-4.8-2.71-11.39-2.3-18.67,1.9c-14.67,8.47-26.57,29.07-26.57,46.01c0,8.46,2.97,14.4,7.76,17.18v0l0.02,0.01c0,0,0,0,0,0 l9.84,5.62l2.35-3.93c2.43-0.56,4.95-1.42,7.62-2.96c14.67-8.47,26.57-29.07,26.57-46.01c0-2.52-0.34-4.73-0.83-6.79 L149.41,106.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2867_",
    className: "st6",
    d: "M129.86,107.65c-14.67,8.47-26.57,29.07-26.57,46.01s11.89,23.81,26.57,15.34 c14.67-8.47,26.57-29.07,26.57-46.01S144.53,99.17,129.86,107.65z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2880_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1875_",
    className: "st7",
    d: "M121.59,140.32c-0.17-0.16-0.24-0.4-0.2-0.74c0.04-0.34,0.17-0.67,0.39-0.99l8.04-11.95 c0.2-0.29,0.4-0.57,0.61-0.84c0.21-0.28,0.44-0.49,0.68-0.63l2.89-1.67c0.27-0.16,0.51-0.18,0.7-0.06 c0.2,0.11,0.3,0.33,0.3,0.64v27.63c0,0.31-0.1,0.64-0.3,0.98c-0.2,0.34-0.43,0.59-0.7,0.75l-3,1.73 c-0.27,0.16-0.51,0.18-0.7,0.06c-0.2-0.11-0.3-0.33-0.3-0.64v-21.13l-5.26,7.78c-0.22,0.33-0.46,0.54-0.72,0.65 c-0.26,0.11-0.49,0.09-0.69-0.05L121.59,140.32z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Mailbox"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1871_"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "MailBox_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2540_",
    className: "st5",
    d: "M366.61,237.33v-1.79h0.44c0.51-1.04,1.48-2.03,2.9-2.85c4.46-2.57,11.68-2.57,16.14,0 c1.42,0.82,2.38,1.8,2.9,2.85h0.44v1.73c0.04,1.71-1.07,3.43-3.34,4.74c-4.46,2.57-11.68,2.57-16.14,0 C367.71,240.72,366.6,239.02,366.61,237.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2524_",
    className: "st6",
    d: "M386.09,230.88c-4.46-2.57-11.68-2.57-16.14,0c-4.46,2.57-4.46,6.75,0,9.32 c4.46,2.57,11.68,2.57,16.14,0C390.55,237.62,390.55,233.45,386.09,230.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2523_",
    className: "st4",
    d: "M380.96,166.97l0,67.78c0,0.43-0.29,0.87-0.86,1.2c-1.15,0.66-3.01,0.66-4.15,0 c-0.57-0.33-0.86-0.77-0.86-1.2l0-67.78H380.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2518_",
    className: "st5",
    points: "375.08,174.38 375.08,176.5 380.96,179.89 380.96,177.78  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2517_",
    className: "st6",
    d: "M412.59,149.05L412.59,149.05l-0.5,1.01l-5.38,10.79l-2.55,5.12l-8.64,17.33l-0.95,1.91 c-0.06,0-0.11,0.01-0.17,0.01c-0.35,0-0.7-0.08-0.97-0.23l-38.5-22.26c-0.54-0.31-0.97-1.06-0.97-1.68v-14.85 c0-7.42,4.89-16.26,10.92-19.74c2.86-1.65,5.45-1.78,7.4-0.69l0.01-0.02L412.59,149.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2516_",
    className: "st4",
    d: "M405.32,149.84c-2.43,0.9-11.29,8.22-11.29,19.73c0,9.68,0.01,14.71,0.01,15.61 c0.12,0.02,0.24,0.03,0.36,0.03c0.06,0,0.11,0,0.17-0.01l0.95-1.91l8.64-17.33l2.55-5.12l0.58-1.17L405.32,149.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2515_",
    className: "st4",
    d: "M415.76,173.04C415.76,173.04,415.76,173.04,415.76,173.04c-0.07,0.13-0.21,0.27-0.4,0.39 c-0.03,0.02-0.07,0.04-0.1,0.06l-19.89,11.48c-0.22,0.13-0.51,0.21-0.8,0.23c-0.06,0-0.11,0.01-0.17,0.01v-15.64 c0-2.67,0.64-5.52,1.73-8.24l0.98,0.57l7.05,4.07l10.95,6.32c0,0,0.25,0.15,0.56,0.32C415.83,172.71,415.85,172.86,415.76,173.04 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2502_",
    className: "st6",
    d: "M412.59,149.05c-1.93-1.01-4.48-0.84-7.27,0.78c-3.14,1.8-5.96,5.07-7.95,8.82 c-0.46,0.87-0.87,1.76-1.24,2.67c-1.09,2.72-1.73,5.57-1.73,8.24v15.64c0.06,0,0.11,0,0.17-0.01c0.29-0.02,0.58-0.1,0.8-0.23 l19.89-11.48c0.03-0.02,0.07-0.04,0.1-0.06c0.15-0.1,0.28-0.24,0.4-0.39c0,0,0,0,0,0c0.28-0.36,0.47-0.82,0.47-1.22v-14.85 C416.22,152.99,414.82,150.23,412.59,149.05z M414.81,172.45l-19.01,10.97c-0.16,0.09-0.29,0.02-0.29-0.17v-13.69 c0-2.39,0.55-5.04,1.59-7.67c0.02-0.05,0.04-0.1,0.06-0.15c0.39-0.97,0.83-1.92,1.33-2.82c1.93-3.57,4.57-6.5,7.38-8.12 c1.45-0.84,2.82-1.26,4.07-1.26c0.79,0,1.51,0.18,2.14,0.51c1.9,1.01,3.02,3.47,3.02,6.91v14.99 C415.1,172.14,414.97,172.36,414.81,172.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2396_",
    className: "st5",
    d: "M415.1,156.96v15.32l-18-10.39c0.02-0.05,0.04-0.1,0.06-0.15 c1.93-4.82,5.18-8.91,8.71-10.94c1.45-0.84,2.82-1.26,4.07-1.26C413.13,149.54,415.1,152.39,415.1,156.96z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2390_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2395_",
    className: "st9",
    d: "M382.16,164.6l1.58-0.91l0,0l0.01-0.01l0,0c0.54-0.31,1.29-0.26,2.11,0.22 c1.66,0.96,3,3.28,3,5.2c0,0.96-0.34,1.63-0.88,1.94v0l0,0l0,0l-1.47,0.84l-0.27-0.44c-0.27-0.06-0.56-0.16-0.86-0.33 c-1.66-0.96-3-3.28-3-5.2c0-0.28,0.04-0.53,0.09-0.77L382.16,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2391_",
    className: "st7",
    d: "M384.35,164.77c1.66,0.96,3,3.28,3,5.2c0,1.91-1.34,2.69-3,1.73c-1.66-0.96-3-3.28-3-5.2 C381.34,164.59,382.69,163.81,384.35,164.77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2387_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2388_",
    className: "st14",
    d: "M384.35,169.06c-0.48,0-0.87-0.39-0.87-0.87v-24.6c0-0.48,0.39-0.87,0.87-0.87 c0.48,0,0.87,0.39,0.87,0.87v24.6C385.22,168.67,384.83,169.06,384.35,169.06z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2386_",
    className: "st3",
    points: "383.48,146.01 374.76,140.98 377.49,146.23 374.76,148.33 383.48,153.37  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1868_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1870_",
    d: "M415.1,156.96c0-4.58-1.98-7.42-5.16-7.42c-1.25,0-2.62,0.42-4.07,1.26 c-3.53,2.03-6.78,6.12-8.71,10.94c-0.02,0.05-0.04,0.1-0.06,0.15l0,0c-1.04,2.64-1.59,5.28-1.59,7.67v16.38l19.59-11.3V156.96z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1870_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Letter_3_",
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2496_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2500_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2501_",
    className: "st16",
    d: "M410.56,161.98c0-0.25-0.17-0.54-0.39-0.67l-19.72-11.38c-0.21-0.12-0.56-0.12-0.77,0 l-0.43,0.25c-0.21,0.12-0.39,0.42-0.39,0.67v15.11c0,0.24,0.17,0.55,0.39,0.67l19.72,11.38c0.21,0.12,0.56,0.12,0.77,0 l0.43-0.25c0.21-0.12,0.39-0.42,0.39-0.67V161.98z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2495_",
    className: "st7",
    d: "M410.45,161.6l-1.09,0.63l-20.37-11.76c0.07-0.12,0.17-0.23,0.27-0.29l0.44-0.25 c0.21-0.12,0.56-0.12,0.77,0l19.72,11.38C410.28,161.37,410.38,161.48,410.45,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2399_",
    className: "st9",
    d: "M410.56,161.98v15.11c0,0.25-0.17,0.55-0.39,0.67l-0.43,0.25 c-0.03,0.02-0.07,0.03-0.11,0.05c-0.05,0.02-0.1,0.03-0.16,0.04c-0.1,0.01-0.21,0.01-0.3-0.01c-0.03-0.01-0.05-0.01-0.07-0.02 c-0.02-0.01-0.03-0.01-0.05-0.02c0.07,0.03,0.13,0.02,0.18,0c0.07-0.04,0.12-0.13,0.12-0.25v-15.11c0-0.16-0.08-0.28-0.2-0.33 l0.2-0.12l1.09-0.63C410.52,161.72,410.56,161.86,410.56,161.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1987_",
    className: "st9",
    d: "M409.36,162.23l-9.13,3.41c-0.65,0.24-1.38,0-1.76-0.58l-1.47-2.25l-8.09-12.39l7.8,12.47 l-7.84,3.07c0,0.12,0.05,0.26,0.12,0.38l7.74-3.42l1.7,2.73c0.39,0.63,1.18,0.87,1.86,0.57l1.21-0.54l7.74,12.34 c0.07-0.04,0.12-0.13,0.12-0.25v-0.25l-7.82-11.86L409.36,162.23z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1869_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2566_",
    className: "st6",
    d: "M428.23,159.52l-2.09,1.74c-0.44,0.66-1.02,1.42-1.79,2.3l-6,6.93l-2.12,2.45l-13.64,7.88 l-6.52,5.41c-0.02,0.01-0.04,0.01-0.06,0.01c-0.19,0.03-0.41,0-0.57-0.09l-0.61-0.35c0,0-0.01,0-0.01-0.01 c-0.22-0.14-0.27-0.41-0.1-0.61c0.01,0,0.01-0.01,0.01-0.01l4.76-5.5l0.01-0.01c0.94-1.08,1.96-2.26,3.03-3.49 c4.48-5.19,13.01-12.21,19.03-15.69c2.82-1.62,4.58-2.18,5.21-1.79l0.01-0.01l1.43,0.83 C428.21,159.52,428.22,159.52,428.23,159.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2568_",
    className: "st4",
    d: "M425.82,164.42l-3.96,4.57c-0.02,0.02-0.04,0.06-0.08,0.1l-3.76,4.33 c-0.18,0.21-0.52,0.49-0.76,0.63l-20.96,12.1c-0.07,0.04-0.15,0.07-0.23,0.08c-0.02,0.01-0.04,0.01-0.06,0.01 c0.67-0.78,3.77-4.36,7.56-8.73h0.01c0.13-0.16,0.28-0.32,0.42-0.49c4.48-5.18,13.01-12.2,19.03-15.68 c2.75-1.59,4.51-2.16,5.18-1.83c0,0.01,0.01,0.01,0.02,0.01C428.99,159.94,428.24,161.63,425.82,164.42z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.08b934a382905d648ab0eaabe743f24b.svg";
export { ForwardRef as ReactComponent };